import { render, staticRenderFns } from "./appendix-recall.vue?vue&type=template&id=058b3898"
import script from "./appendix-recall.vue?vue&type=script&lang=js"
export * from "./appendix-recall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports